export default __webpack_public_path__ + "static/p13-b11900c164ca45cb239d85f994c77ac9.png";